import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-scroll-to-top',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './scroll-to-top.component.html',
  styleUrl: './scroll-to-top.component.css'
})
export class ScrollToTopComponent {
  isVisible = false; // Control the button's visibility

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Show the button when the user scrolls down 100 pixels
    this.isVisible = window.scrollY > 100;
  }

  scrollToTop() {
    // Smooth scroll to the top
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
